import $ from "jquery";
import { OUTLINE_WRAPPER_SELECTOR } from "../4-one-of-one/_selectors";
import { OUTLINE_REMOVE_BUTTON } from "../constants/selectors";

function resetOutline() {
	if ($(OUTLINE_WRAPPER_SELECTOR).length > 0) {
		console.log("reset outline");
		$(OUTLINE_WRAPPER_SELECTOR).show("fast", function () {
			if ($(OUTLINE_REMOVE_BUTTON).length > 0) {
				$(OUTLINE_REMOVE_BUTTON).trigger("click");
			}
		});
	}
}

export default resetOutline;
